import Environment from '../constants/Environment';

const HOST_BY_ENVIRONMENT: {[x in Environment]?: string} = {
  [Environment.DEVELOPMENT]: 'localhost',
  [Environment.RAINFORESTQA]: 'rainforestqa.sandbox-ezcater.com',
  [Environment.SANDBOX]: 'sandbox-ezcater.com',
  [Environment.STAGING]: 'staging-ezcater.com',
};

const environments = Object.keys(Environment).map(
  (key: string) => Environment[key as keyof typeof Environment]
);

interface WindowWithOptionalOrigin {
  location: {
    origin?: string;
  };
}

const getEnvironment = (currentWindow?: WindowWithOptionalOrigin): Environment => {
  if (currentWindow?.location?.origin == null) {
    return Environment.PRODUCTION;
  }

  const {origin} = currentWindow.location;
  const matchingEnvironment = environments.find((environment: Environment) => {
    const host = HOST_BY_ENVIRONMENT[environment];
    return host ? origin.indexOf(host) !== -1 : null;
  });

  return matchingEnvironment || Environment.PRODUCTION;
};

export default getEnvironment;
